<template>
  <div v-if="isMobile">
    <app-register
      v-for="index in history.length"
      :key="index"
      :history="history[index - 1]"
      @clicked="callDownload"
    >
    </app-register>
  </div>
  <div v-else>
    <v-data-table
      :items="history"
      :headers="historyHeaders"
      class="elevation-1 rounded no-first"
      :disable-pagination="true"
      :hide-default-footer="true"
      :no-data-text="tableText"
    >
      <template v-slot:[`item.IsPrintable`]="{ item }">
        <a v-if="item.IsPrintable" @click="callDownload(item.RegisterID)"
          >دریافت مدرک</a
        >
      </template>
      <template v-slot:[`item.Icon`]="{ item }">
        <font-awesome-icon :icon="item.Icon" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Register from "./Register";
import { downloadMadrak } from "@/api/sabtenam";
import { saveByteArray } from "@/utils/constants";
export default {
  components: {
    appRegister: Register,
  },
  data() {
    return {
      historyHeaders: [
        {
          text: "",
          value: "RegisterID",
          width: "0%",
          sortable: false,
        },
        {
          text: "نام دوره",
          value: "Title",
          width: "45%",
        },
        {
          text: "تاریخ شروع دوره",
          value: "TarikhStart",
          width: "15%",
        },       
        {
          text: "امتیاز",
          value: "Score",
          width: "10%",
        },
        {
          text: "وضعیت",
          value: "IsPrintableName",
          width: "15%",
          sortable: false,
        },
        {
          text: "",
          value: "IsPrintable",
          width: "15%",
          sortable: false,
        },

      ],
    };
  },
  created() {
    this.$store.dispatch("getSabtenamHistory");
  },
  computed: {
    history() {
      return this.$store.getters.registersHistory;
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },

  methods: {
    callDownload(index) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadMadrak(index)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
};
</script>
